import React, { useEffect, useState } from 'react';
import { useGlobalProvider } from '../contexts/GlobalProvider';
import { fetchTopFolders } from '../api/topFoldersService';
import { useAuth } from "../contexts/AuthContext";

const GetTopFolders = () => {
  const {
    selectedProjectId,
    selectedHubId,
    setAccTopFolder,
  } = useGlobalProvider();

  const { getAccessToken } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // More robust validation for project and hub IDs
    if (!selectedProjectId || 
        selectedProjectId.trim() === '' || 
        selectedProjectId === 'null' || 
        selectedProjectId === 'undefined' ||
        !selectedHubId || 
        selectedHubId.trim() === '' || 
        selectedHubId === 'null' || 
        selectedHubId === 'undefined') {
      console.log('GetTopFolders: Invalid or missing project/hub ID', { selectedProjectId, selectedHubId });
      return;
    }

    setIsLoading(true);
    setError(null);

    (async () => {
      try {
        const token = await getAccessToken();
        if (!token) {
          console.log('GetTopFolders: No access token available, skipping fetch');
          setAccTopFolder([]);
          return;
        }

        const data = await fetchTopFolders({
          selectedProjectId,
          selectedHubId,
          accessToken: token,
        });
        console.log('Raw API response:', data);
        
        // The API returns data in the 'data' property
        const list = Array.isArray(data.data) ? data.data : [];
        console.log('Processed top folders list:', list);
        
        setAccTopFolder(list);  // update global here
      } catch (err) {
        console.error('Error fetching top folders:', err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [selectedProjectId]);

  return (
      <div>
        {isLoading && <p>Loading top folders...</p>}
        {error && <p>Error: {error.message || error}</p>}
      </div>
  );
};

export default GetTopFolders;
